import { getQueryParams } from "../../../shared/utils";

/**
 * A Steam invite reaches the game one of two ways:
 *  - cold start: Steam launches us with +connect_lobby <id>, which desktop/index.js
 *    forwards to the renderer as the steamLobby query param.
 *  - already running: Steam fires GameLobbyJoinRequested, which the main process
 *    pushes over IPC.
 * Both end up here so the rest of the client has one place to ask for the lobby to join.
 */

let pendingLobbyId: string | undefined;
let subscribed = false;
const listeners: ((lobbyId: string) => void)[] = [];

const listenForInvites = () => {
	if (subscribed || !window.electronApi?.onSteamLobbyJoinRequested) return;
	subscribed = true;
	window.electronApi.onSteamLobbyJoinRequested(({ lobbyId }) => {
		if (!lobbyId) return;
		console.log('Steam invite received for lobby ' + lobbyId);
		pendingLobbyId = lobbyId;
		for (const listener of [...listeners]) {
			listener(lobbyId);
		}
	});
};

// Electron always passes a steamLobby param, empty when we weren't launched from an invite
pendingLobbyId = getQueryParams(window.location.href)['steamLobby'] || undefined;
listenForInvites();

export function getPendingSteamLobbyId(): string | undefined {
	return pendingLobbyId;
}

/** An invite is good for one join attempt; a failed one shouldn't silently retry a dead lobby. */
export function clearPendingSteamLobbyId() {
	pendingLobbyId = undefined;
}

/** Returns an unsubscribe function. */
export function onSteamInvite(listener: (lobbyId: string) => void): () => void {
	listenForInvites();
	listeners.push(listener);
	return () => {
		const index = listeners.indexOf(listener);
		if (index !== -1) {
			listeners.splice(index, 1);
		}
	};
}
